import { cadenzaSessionStorage } from '@disy/lib/storage';

import { getStore } from 'cadenza/store/cadenza-store';
import { isOperationModeSimplified, saveOperationMode } from 'cadenza/workbook/operation-mode';
import { isWorkbookVisibilityRestricted } from 'cadenza/workbook/workbook-core-selectors.state';
import { USER_MESSAGE_STORAGE_KEY } from 'cadenza/workbook/workbook-session-storage';

import i18n from './toggle-simplified-mode.properties';

export function toggleOperationModeSimplified(storeMessage = false) {
  if (!isWorkbookVisibilityRestricted(getStore().getState())) {
    const newOperationMode = isOperationModeSimplified(getStore().getState()) ? 'normal' : 'simplified';
    saveOperationMode(getStore().getState(), newOperationMode);
    if (storeMessage) {
      cadenzaSessionStorage.setItem(
        USER_MESSAGE_STORAGE_KEY,
        i18n(`simplified-operation.active.<${newOperationMode === 'simplified'}>.toast-message`),
      );
    }
    location.reload();
  }
}
